import * as React from 'react';

import {colors} from '../colors/colors';
import {Link} from '../link/link';
import {Metric} from '../metrics/metric';
import {Percentage} from '../percentage/percentage';
import {ProgressBar} from '../progress-bar/progress-bar';

import styles from './stat-item.module.css';

type Stat = {
    rate: number | null | undefined;
    count: number | null | undefined;
    linkTo: string;
};

export type Props = {
    stat: Stat;
    nounSingular: string;
    nounPlural: string;
    isLoading: boolean;
    color?: string;
};

export function StatItem(props: Props) {
    const rate = props.stat.rate ? props.stat.rate : 0;
    const count = props.stat.count ? props.stat.count : 0;

    return (
        <div className={styles['stat-item']}>
            <div className={styles['progress-bar-wrapper']}>
                <Link to={props.stat.linkTo}>
                    <ProgressBar
                        percentComplete={rate}
                        height={36}
                        backgroundColor={colors.offWhite}
                        color={props.color}
                    />
                </Link>
                <Metric
                    // @ts-expect-error
                    value={<Percentage value={rate} />}
                    isLoading={props.isLoading}
                    size='normal'
                />
            </div>
            <Metric
                value={<div>{props.isLoading ? '-' : count}</div>}
                secondaryValue={{
                    value: count,
                    nounSingular: props.nounSingular,
                    nounPlural: props.nounPlural,
                    hideValue: true,
                }}
                size='small'
                wrapWithDiv={true}
            />
        </div>
    );
}
